import { useContext } from 'react';
import { AuthDialogContext } from './AuthDialogProvider';

export default function useAuthDialog() {
  return useContext(AuthDialogContext);
};
